import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { TextLoca } from "../../generic/text/TextLoca";
import { BuildingItemContainer } from "../../player-base/buildings/upgrade/BuildingItemContainer";
export var OutskirtBuildingUpgradeMaxLevel = function (_a) {
    var buildingName = _a.buildingName, buildingStage = _a.buildingStage;
    return (React.createElement("div", { className: "outskirt-building-upgrade" },
        React.createElement(BuildingItemContainer, { className: "building-old__container", buildingName: buildingName, stage: buildingStage }),
        React.createElement(TextLoca, { id: IdLoca.maxLevelReached, className: IdStyles.TextBoldPrimary })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/upgrade/OutskirtBuildingUpgradeMaxLevel.tsx
// module id = 2638
// module chunks = 3